import React from "react";

import { ArtifactIcon } from "src/icons/NewUX/ArtifactIcon";
import { ChartIcon } from "src/icons/NewUX";
import { DatasetIcon } from "src/icons/NewUX/DatasetIcon";
import { ModelIcon } from "src/icons/NewUX/ModelIcon";

export const projectRegExpLiteralNotations = {
  jobs: /jobs/,
  jobCanvasCompare: /job-compare/,
  jobCanvas: /job-canvas/
};

export enum NodeTypes {
  Dataset = "ENTITY",
  Recipe = "DFSGROUP",
  Chart = "CHART",
  Artifact = "ARTIFACT",
  Model = "MODEL"
}

export enum NodeTypeNames {
  Dataset = "Dataset",
  Recipe = "Recipe",
  Chart = "Chart",
  Artifact = "Artifact",
  Model = "Model"
}

export const NodeTypesNameMapping: $TSFixMe = {
  [NodeTypes.Dataset]: NodeTypeNames.Dataset,
  [NodeTypes.Recipe]: NodeTypeNames.Recipe,
  [NodeTypes.Chart]: NodeTypeNames.Chart,
  [NodeTypes.Artifact]: NodeTypeNames.Artifact,
  [NodeTypes.Model]: NodeTypeNames.Model
};

export const NodeTypesSessionKeyMapping: $TSFixMe = {
  [NodeTypes.Dataset]: "selectedEntities",
  [NodeTypes.Artifact]: "selectedArtifacts",
  [NodeTypes.Model]: "selectedModels"
};

export const NodeTypesIconMapping: $TSFixMe = {
  [NodeTypes.Dataset]: <DatasetIcon width={18} height={18} viewBox="-1 0 20 20" />,
  [NodeTypes.Chart]: <ChartIcon width={18} height={20} viewBox="-2 -4 40 40" />,
  [NodeTypes.Artifact]: <ArtifactIcon width={18} height={18} viewBox="-2 0 17 17" />,
  [NodeTypes.Model]: <ModelIcon width={22} height={22} viewBox="-2 -2 20 20" />
};

export enum RecipeTypes {
  AiAssisted = "CODE",
  RapidModel = "AUTO_ML",
  Template = "STANDARD",
  ApiConnector = "API_CONNECTOR"
}

export enum RecipeTypeNames {
  AiAssisted = "AI-assisted",
  RapidModel = "Rapid Model",
  Template = "Template",
  ApiConnector = "API Connector"
}

export const RecipeTypesNameMapping = {
  [RecipeTypes.AiAssisted]: RecipeTypeNames.AiAssisted,
  [RecipeTypes.RapidModel]: RecipeTypeNames.RapidModel,
  [RecipeTypes.Template]: RecipeTypeNames.Template,
  [RecipeTypes.ApiConnector]: RecipeTypeNames.ApiConnector
};

export const RecipeTypesPathMapping = {
  [RecipeTypes.AiAssisted]: "add-code-recipe" as const,
  [RecipeTypes.Template]: "add-recipe" as const,
  [RecipeTypes.RapidModel]: "add-auto-ml-recipe" as const,
  [RecipeTypes.ApiConnector]: "api-connector-recipe" as const
};

export enum DatasetStatuses {
  UnBuilt = "UNBUILT",
  Pending = "PENDING",
  Empty = "EMPTY",
  Skipped = "SKIPPED",
  Built = "BUILT"
}

export enum RecipeStatuses {
  UnBuilt = "UNBUILT",
  Pending = "PENDING",
  Empty = "EMPTY",
  Running = "RUNNING",
  Success = "SUCCESS",
  Error = "ERROR",
  Skipped = "SKIPPED"
}

export enum ChartStatuses {
  UnBuilt = "UNBUILT",
  Pending = "PENDING",
  Empty = "EMPTY",
  Skipped = "SKIPPED",
  Built = "BUILT"
}

export enum ArtifactStatuses {
  UnBuilt = "UNBUILT",
  Empty = "EMPTY",
  Skipped = "SKIPPED",
  Built = "BUILT"
}

export enum ModelStatuses {
  UnBuilt = "UNBUILT",
  Empty = "EMPTY",
  Skipped = "SKIPPED",
  Built = "BUILT"
}
